const LogOutIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 28" width="28" height="28">
            <path fill="#f23645"
                  d="M8.5 5A4.5 4.5 0 0 0 4 9.5v10A4.5 4.5 0 0 0 8.5 24H16v-1H8.5A3.5 3.5 0 0 1 5 19.5v-10A3.5 3.5 0 0 1 8.5 6H16V5H8.5Zm12.35 5.65a.5.5 0 0 0-.7.7L22.79 14H13a.5.5 0 0 0 0 1h9.8l-2.65 2.65a.5.5 0 0 0 .7.7l3.5-3.5a.5.5 0 0 0 0-.7l-3.5-3.5Z"></path>
        </svg>
    )
}

export default LogOutIcon